import type { StateCreator } from 'zustand';
import type { GameState } from '../types';

export type ShowKey =
  | 'showDisclaimerModal'
  | 'showAdModal'
  | 'showBoostModal'
  | 'showReviveModal'
  | 'showDebtModal'
  | 'showLaborSummaryModal'
  | 'showLaborScreen'
  | 'showLiqScreen'
  | 'showRankScreen'
  | 'showPctOverlay';

export interface UiSlice {
  toast: string;
  toastId: number;

  showDisclaimerModal: boolean;
  showAdModal: boolean;
  showBoostModal: boolean;
  showReviveModal: boolean;
  showDebtModal: boolean;
  showLaborSummaryModal: boolean;
  showLaborScreen: boolean;
  showLiqScreen: boolean;
  showRankScreen: boolean;
  showPctOverlay: boolean;

  showToast: (msg: string) => void;
  setShow: (key: ShowKey, v: boolean) => void;
}

export const createUiSlice: StateCreator<GameState, [], [], UiSlice> = (set) => ({
  toast: '',
  toastId: 0,

  showDisclaimerModal: false,
  showAdModal: false,
  showBoostModal: false,
  showReviveModal: false,
  showDebtModal: false,
  showLaborSummaryModal: false,
  showLaborScreen: false,
  showLiqScreen: false,
  showRankScreen: false,
  showPctOverlay: false,

  showToast: (msg) => set((s) => ({ toast: msg, toastId: s.toastId + 1 })),
  setShow: (key, v) => set({ [key]: v } as Partial<GameState>),
});
